import {
  CircleCheck,
  CircleSlash,
  CircleX,
  Info,
  type LucideIcon,
  Timer,
  TriangleAlert,
} from "@/shared/foundation/icons";
import { type StatusTone } from "@/shared/foundation/primitives";

import { type RunPythonOutcomeKind } from "./runPythonPayload";

/** Each outcome's tone and icon, shared by the card's badge and the pill so the two always agree. */
export const RUN_PYTHON_OUTCOME_LOOK: Record<
  RunPythonOutcomeKind,
  { tone: StatusTone; icon: LucideIcon }
> = {
  completed: { tone: "success", icon: CircleCheck },
  failed: { tone: "danger", icon: CircleX },
  timed_out: { tone: "warning", icon: Timer },
  stopped: { tone: "neutral", icon: CircleSlash },
  sandbox_error: { tone: "danger", icon: TriangleAlert },
  unknown: { tone: "neutral", icon: Info },
};
